import * as React from 'react'

import { InfoIcon } from 'lucide-react'

import TooltipWrapper from '~/client/src/shared/components/TooltipWrapper/TooltipWrapper'

interface IProps {
  tooltipContent: string | JSX.Element
}

export default function InfoIconWithTooltip(props: IProps) {
  return (
    <TooltipWrapper className="row no-grow" content={props.tooltipContent}>
      <InfoIcon size={16} className="tw:block tw:text-muted-foreground" />
    </TooltipWrapper>
  )
}
